import './App.css';
import { useEffect, useState } from 'react';

const TERMS_EFFECTIVE_DATE = 'April 10, 2026';
const TERMS_UPDATED_DATE = 'April 10, 2026';
const CONTACT_EMAIL = 'yuw558071@gmail.com';
const CONTACT_WEBSITE = 'https://yuwenhao.site';

function getPageFromLocation(locationValue) {
  if (locationValue.pathname === '/terms' || locationValue.pathname === '/terms/') {
    return 'terms';
  }
  if (locationValue.pathname === '/privacy' || locationValue.pathname === '/privacy/') {
    return 'privacy';
  }
  if (locationValue.hash === '#terms') {
    return 'terms';
  }
  if (locationValue.hash === '#privacy') {
    return 'privacy';
  }
  return 'home';
}

function App() {
  const [page, setPage] = useState(() => getPageFromLocation(window.location));

  useEffect(() => {
    const handleLocationChange = () => {
      setPage(getPageFromLocation(window.location));
    };

    window.addEventListener('hashchange', handleLocationChange);
    window.addEventListener('popstate', handleLocationChange);
    return () => {
      window.removeEventListener('hashchange', handleLocationChange);
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  return (
    <div className="site-shell">
      <header className="topbar">
        <a className="brand" href="/">
          All Clean
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="/">Home</a>
          <a href="/terms/">Terms</a>
          <a href="/privacy/">Privacy</a>
        </nav>
      </header>

      <main className="content">
        {page === 'home' && <HomePage />}
        {page === 'terms' && <TermsPage />}
        {page === 'privacy' && <PrivacyPage />}
      </main>

      <footer className="footer">
        <p>
          Contact: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> |{' '}
          <a href={CONTACT_WEBSITE} target="_blank" rel="noreferrer">
            {CONTACT_WEBSITE}
          </a>
        </p>
      </footer>
    </div>
  );
}

function HomePage() {
  return (
    <section className="panel hero">
      <h1>All Clean Official Website</h1>
      <p>
        All Clean helps users scan and manage storage on Android devices, including junk
        cleanup, large file detection, duplicate file detection, APK management, and key
        device status insights.
      </p>
      <p>
        Please review our legal documents before using the app. Choose one of the two pages
        below:
      </p>

      <div className="entry-grid">
        <a className="entry-card" href="/terms/">
          <h2>Terms of Service</h2>
          <p>Includes disclaimer and limitation of liability.</p>
        </a>
        <a className="entry-card" href="/privacy/">
          <h2>Privacy Policy</h2>
          <p>Google Play and GDPR-adapted privacy notice.</p>
        </a>
      </div>
    </section>
  );
}

function TermsPage() {
  return (
    <article className="panel legal">
      <h1>Terms of Service (Including Disclaimer)</h1>
      <p className="meta">
        Effective Date: {TERMS_EFFECTIVE_DATE} | Last Updated: {TERMS_UPDATED_DATE}
      </p>
      <p>
        Welcome to All Clean. By using this application, you acknowledge that you have read
        and agree to these Terms of Service.
      </p>

      <h2>1. Scope of Application</h2>
      <p>
        These Terms apply to your access to and use of this application and related services.
        If you do not agree, please stop using the app.
      </p>

      <h2>2. Service Content</h2>
      <p>
        This app provides device cleanup and storage management features, including but not
        limited to:
      </p>
      <ul>
        <li>Junk file scanning and cleanup</li>
        <li>Large file detection</li>
        <li>Duplicate file detection</li>
        <li>APK file identification and management</li>
        <li>Device status display (storage, memory, battery, etc.)</li>
      </ul>
      <p>
        We may adjust, add, suspend, or terminate certain features based on product updates.
      </p>

      <h2>3. Eligibility and User Obligations</h2>
      <p>You represent and warrant that you:</p>
      <ul>
        <li>Have legal capacity to enter into and perform these Terms;</li>
        <li>Will use this app lawfully and in compliance with applicable regulations;</li>
        <li>
          Will independently confirm file necessity and back up important data before deletion
          or cleanup operations;
        </li>
        <li>
          Will not interfere with normal service operation through reverse engineering,
          cracking, abusive automation, or similar conduct.
        </li>
      </ul>

      <h2>4. Permissions and Authorization</h2>
      <p>
        You understand and agree that this app may request storage/media access permissions to
        deliver core functionality.
      </p>
      <p>
        You may choose whether to grant permission. Refusing permission may cause certain
        features to be unavailable.
      </p>

      <h2>5. Advertising and Third-Party Services</h2>
      <p>
        This app may display third-party advertisements and integrate third-party SDKs.
        Third-party services are provided independently and governed by their own terms and
        privacy policies. We are not directly responsible for third-party conduct, unless
        otherwise required by law.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        The software, interface, marks, texts, and related intellectual property rights of this
        app belong to us or the relevant rights holders.
      </p>
      <p>
        Without permission, you may not copy, modify, distribute, lease, sell, or use them for
        commercial redistribution.
      </p>

      <h2>7. Disclaimer (Important)</h2>
      <p>To the extent permitted by law:</p>
      <ul>
        <li>
          This app is provided on an "as is" and "as available" basis, without warranties of
          uninterrupted operation, error-free service, or completeness;
        </li>
        <li>
          Cleanup recommendations are based on algorithms and device conditions and do not
          constitute an absolute promise of outcomes;
        </li>
        <li>
          You choose deletion actions at your own discretion and risk. Risks such as data loss
          or abnormal behavior caused by accidental deletion, system limitations, or manufacturer
          compatibility are borne by you;
        </li>
        <li>
          This app does not provide data recovery guarantees and is not liable for any indirect,
          incidental, or punitive damages.
        </li>
      </ul>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the extent permitted by applicable law, our aggregate liability to you is limited to
        the amount you directly paid to use this app (typically 0 for a free app).
      </p>
      <p>
        If local law does not allow certain limitations, the maximum limitation permitted by law
        shall apply.
      </p>

      <h2>9. Service Changes, Interruption, and Termination</h2>
      <p>
        We may maintain, upgrade, or interrupt services when necessary. If you violate these
        Terms or applicable laws, we may restrict or terminate your access to the services.
      </p>

      <h2>10. Privacy and Data Protection</h2>
      <p>
        Your data is handled in accordance with the Privacy Policy. The Privacy Policy forms an
        integral part of these Terms.
      </p>

      <h2>11. Updates to These Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use after updates constitutes
        acceptance of the updated Terms.
      </p>

      <h2>12. Contact Information</h2>
      <p>
        Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        <br />
        Website:{' '}
        <a href={CONTACT_WEBSITE} target="_blank" rel="noreferrer">
          {CONTACT_WEBSITE}
        </a>
      </p>
    </article>
  );
}

function PrivacyPage() {
  return (
    <article className="panel legal">
      <h1>Privacy Policy (Google Play + GDPR Adapted)</h1>
      <p className="meta">
        Effective Date: {TERMS_EFFECTIVE_DATE} | Last Updated: {TERMS_UPDATED_DATE}
      </p>
      <p>
        This Privacy Policy applies to All Clean, an Android application developed and
        published by 2X Happiness. It explains how we handle data related to you.
      </p>

      <h2>1. Scope</h2>
      <p>
        This Policy applies to data processing activities generated when you use this app on
        Android devices.
      </p>

      <h2>2. Who We Are (Data Controller)</h2>
      <p>
        App Name: All Clean
        <br />
        Developer/Operator: 2X Happiness
        <br />
        Contact Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>

      <h2>3. What Data We Process</h2>
      <h3>3.1 Data Processed Locally on Device (Not Uploaded by Default)</h3>
      <p>
        To provide features such as junk cleanup, duplicate file detection, large file
        detection, and APK management, the app reads and analyzes file-related information on
        your device locally, for example:
      </p>
      <ul>
        <li>File path, file name, size, modified time, media type</li>
        <li>Index information in system media library (MediaStore) for images/videos/audio</li>
        <li>
          Cleanup statistics (such as total space freed, cleanup count, item count; stored
          locally only)
        </li>
        <li>Theme preference settings (stored locally only)</li>
      </ul>
      <p>
        These data are mainly processed on your device to present scan results and perform
        deletion operations.
      </p>

      <h3>3.2 Data That May Be Transmitted to Third Parties (SDKs)</h3>
      <p>
        This app integrates third-party SDKs that may transmit certain data to their servers:
      </p>
      <ul>
        <li>
          Google AdMob (Advertising): May process advertising identifiers (such as AAID), device
          identifier information, IP address, ad interaction data, and coarse device information
          for ad delivery, anti-fraud, and performance measurement.
        </li>
        <li>
          Firebase Analytics (Analytics): May process app events, device and app version
          information, and crash/performance-related metrics, depending on enabled SDK features.
        </li>
      </ul>
      <p>
        Third parties may process data in different regions according to their own policies.
        Please also review their privacy policies.
      </p>

      <h3>3.3 Permissions and Purpose</h3>
      <p>This app may request the following permissions:</p>
      <ul>
        <li>
          READ_MEDIA_IMAGES, READ_MEDIA_VIDEO, READ_EXTERNAL_STORAGE (&lt;= Android 12): used to
          scan media files.
        </li>
        <li>
          MANAGE_EXTERNAL_STORAGE: used for deep storage scanning and cleanup (for example, when
          you actively trigger "full-disk cleanup").
        </li>
      </ul>
      <p>We use permissions only to the extent necessary for core functionality.</p>

      <h2>4. Legal Bases for Processing (GDPR)</h2>
      <p>
        If you are located in the EU/EEA or other applicable regions, we process data based on:
      </p>
      <ul>
        <li>
          Contract performance (GDPR Art. 6(1)(b)): to provide requested cleanup and file
          management features.
        </li>
        <li>
          Legitimate interests (GDPR Art. 6(1)(f)): to ensure app security, stability,
          anti-abuse, and basic analytics.
        </li>
        <li>
          Consent (GDPR Art. 6(1)(a)): where legally required (for example personalized
          advertising/tracking) through compliant consent mechanisms.
        </li>
        <li>
          Legal obligation (GDPR Art. 6(1)(c)): to comply with legal and regulatory requirements.
        </li>
      </ul>

      <h2>5. Data Sharing and Disclosure</h2>
      <p>We do not sell your personal data.</p>
      <p>Data may be shared when necessary:</p>
      <ul>
        <li>
          With third parties providing technical services (such as Google AdMob/Firebase), for
          necessary processing;
        </li>
        <li>To comply with laws, judicial orders, or regulatory requirements;</li>
        <li>To protect the lawful rights and interests of users or the public.</li>
      </ul>

      <h2>6. Cross-Border Transfers</h2>
      <p>
        Due to global infrastructure used by third-party service providers, your data may be
        transferred to countries/regions outside your own.
      </p>
      <p>
        We require relevant parties to implement appropriate safeguards (such as standard
        contractual clauses or other compliant mechanisms).
      </p>

      <h2>7. Data Retention</h2>
      <ul>
        <li>
          Local scan results and statistics: usually retained on your device until you clear app
          data or uninstall the app.
        </li>
        <li>
          Third-party SDK data: retained and deleted by corresponding providers under their
          policies.
        </li>
        <li>Data required by law: retained for the legally required period.</li>
      </ul>

      <h2>8. Your Rights (GDPR)</h2>
      <p>Under applicable law, you may have the right to:</p>
      <ul>
        <li>Access, rectify, and erase your data;</li>
        <li>Restrict or object to processing, and data portability;</li>
        <li>
          Withdraw consent (without affecting the lawfulness of processing before withdrawal);
        </li>
        <li>Lodge a complaint with a supervisory authority.</li>
      </ul>
      <p>
        You may submit requests through the contact details in this Policy. To remove local
        data, you can uninstall the app or clear app data in system settings.
      </p>

      <h2>9. Children&apos;s Privacy</h2>
      <p>
        This app is not directed to children under 13 years old (or the legal minimum age in
        your jurisdiction). If a guardian finds that a minor has provided personal data without
        authorization, please contact us for handling.
      </p>

      <h2>10. Security Measures</h2>
      <p>
        We implement reasonable technical and organizational measures to protect data security,
        but no transmission or storage method can guarantee absolute security.
      </p>

      <h2>11. Policy Updates</h2>
      <p>
        We may update this Policy based on product or legal changes. Updates will be published
        in-app or on the website, and significant changes will be highlighted where required.
      </p>

      <h2>12. Contact Us</h2>
      <p>
        Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        <br />
        Website:{' '}
        <a href={CONTACT_WEBSITE} target="_blank" rel="noreferrer">
          {CONTACT_WEBSITE}
        </a>
      </p>
      <p>Suggested Email Subject: Privacy Request - All Clean</p>

      <h2>13. Third-Party Privacy Links</h2>
      <ul>
        <li>
          Google Privacy Policy:{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
            https://policies.google.com/privacy
          </a>
        </li>
        <li>
          Firebase Privacy &amp; Security:{' '}
          <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">
            https://firebase.google.com/support/privacy
          </a>
        </li>
        <li>
          AdMob Data and Privacy:{' '}
          <a href="https://support.google.com/admob/" target="_blank" rel="noreferrer">
            https://support.google.com/admob/
          </a>
        </li>
      </ul>
    </article>
  );
}

export default App;
